import Vue from 'vue'
import VueRouter from 'vue-router'
import routesConfig from "../config/routesConfig";
import store from "../store";

Vue.use(VueRouter);

let router;
router = new VueRouter({
    routes: routesConfig
});

router.beforeEach(async (to, from, next) => {
    // Force SSLs
    if (window.location.href.match('http:') && process.env.NODE_ENV != 'development') {
        window.location.href = window.location.href.replace('http', 'https')
    }
    document.title = to.meta.title || 'Sign App';
    //redirect user to login if not logged in
    let matched_path = '';
    try {
        //matched sometime empty (on /login for example...)
        matched_path = to.matched[0].path;
    } catch (e) {
    }
    if (matched_path == '/backoffice') {
        //we never sampled the server, this is the first time the app is loading, user is maybe logged in already...
        let isInitialized = store.getters['me/isInitialized'];
        if (!isInitialized) {
            await store.dispatch('me/loadFromServer');
        }
        if (!store.getters['me/isLoggedIn']) {
            next({
                path: '/front/login',
                params: {nextUrl: to.fullPath}
            })
        } else {
            next();
        }
    }
    next();
})

let RouterService = router;
export default RouterService
